export default Object.freeze({
  // MEMBER_SEARCH_
  MALL: '쇼핑몰 선택',

  PAGE_SIZE: '개 보기',

  RESULT_TITLE: '조회결과',
  RESULT_NUM: '건',
});
